import { CharizURL } from "@chariz/utils";
import { srcx } from "img-srcx";
import Dialog from "../shared/Dialog";
import type { HTMLAttributes } from "react";

export enum BuyOpenInAppApp {
	Cydia = "cydia",
	Sileo = "sileo",
	Zebra = "zebra"
}

interface AddRepoProps extends HTMLAttributes<HTMLElement> {
	type: "add-repo";
	repositoryURL?: string;
}

interface OpenPackageProps extends HTMLAttributes<HTMLElement> {
	type: "open-package";
	sku: string;
	packageID: string;
	repositoryURL?: string;
}

type Props = AddRepoProps | OpenPackageProps;

const apps = [
	{ id: BuyOpenInAppApp.Cydia, name: "Cydia", icon: "cydia" },
	{ id: BuyOpenInAppApp.Sileo, name: "Sileo", icon: "sileo" },
	{ id: BuyOpenInAppApp.Zebra, name: "Zebra", icon: "zebra" }
];

export default function BuyOpenInAppDialog({ type, repositoryURL, ...props }: Props) {
	const openIn = (app: BuyOpenInAppApp) => {
		let url: string;
		repositoryURL = repositoryURL ?? CharizURL.url("/repo/");
		switch (type) {
			case "open-package": {
				const { sku, packageID } = props as OpenPackageProps;
				switch (app) {
					case BuyOpenInAppApp.Cydia:
						url = `/buy/${sku}/launch-cydia`;
						break;
					case BuyOpenInAppApp.Sileo:
						url = `sileo://package/${packageID}`;
						break;
					case BuyOpenInAppApp.Zebra:
						url = `zbra://packages/${packageID}?source=${repositoryURL}`;
						break;
				}
				break;
			}

			case "add-repo":
				switch (app) {
					case BuyOpenInAppApp.Cydia:
						url = "/auth/cydia/launch-cydia";
						break;
					case BuyOpenInAppApp.Sileo:
						url = `sileo://source/${repositoryURL}`;
						break;
					case BuyOpenInAppApp.Zebra:
						url = `zbra://sources/add/${repositoryURL}`;
						break;
				}
				break;
		}
		window.location.href = url;
		Dialog.hide(true);
	};

	return (
		<Dialog id="buy-open-in-app-dialog" aria-labelledby="buy-open-in-app-title">
			<div className="modal-body">
				<h2 id="buy-open-in-app-title">Open In…</h2>
				<div className="d-flex flex-row flex-wrap justify-content-between mb-1" role="list">
					{apps.map(({ id, icon, name }) => (
						<div key={id} className="product-item" role="listitem">
							<button className="btn btn-link text-body" onClick={() => openIn(id)}>
								<div className="product-icon">
									<img alt="" {...srcx(`/img/${icon}.png`)} />
								</div>
								<span className="product-name">{name}</span>
							</button>
						</div>
					))}
				</div>
				<p>
					If you haven’t installed a jailbreak on your iOS device, visit{" "}
					<a href="https://ios.cfw.guide/get-started" target="_blank" rel="noreferrer">
						CFW Guide
					</a>{" "}
					to learn more.
				</p>
			</div>
			<div className="modal-buttons">
				<button className="btn btn-primary" onClick={() => Dialog.hide(true)}>
					Cancel
				</button>
			</div>
		</Dialog>
	);
}
